import { Tuple } from "../../utils/tuple";

export const ALL_VENTING_GAS_QUESTIONS = Tuple('vent', 'detonate');
export type VentingGasQuestion = typeof ALL_VENTING_GAS_QUESTIONS[number];
